import { Tabs } from "antd";
import React, { FC } from "react";
import AppHeader from "../../shared/components/AppHeader";
import EmptyState from "../../shared/components/EmptyState";
import BoardAnalytics from "./BoardAnalytics";
import ExamAnalytics from "./ExamAnalytics";
import PreviousPaperAnalytics from "./PreviousPaperAnalytics";
const { TabPane } = Tabs;
const Analytics: FC = () => {
  return (
    <div className="page-view">
      <EmptyState text={"Coming soon..."} />

      {/* <AppHeader
        headerText="Analytics"
        showSearch={false}
        showButton={false}
        showBreadCrumb={false}
        showFilter={false}
        buttonIcon={null}
      />
      <Tabs defaultActiveKey="1" onChange={() => {}} className="analytics__tabs" >
        <TabPane tab="Board" key="1">
          <BoardAnalytics/>
        </TabPane>
        <TabPane tab="Exam" key="2">
          <ExamAnalytics/>
        </TabPane>
        <TabPane tab="Previous paper" key="3">
          <PreviousPaperAnalytics/>
        </TabPane>
        <TabPane tab="Schedule" key="4">    
          Schedule
        </TabPane>
      </Tabs> */}
    </div>
  );
};
export default Analytics;
